<div class="content content--page">
  <div class="content__inner">
    <div class="content__main content__main--page">
      <div class="card card--small">
        <h1 class="card__title">Verify your email</h1>
        <div class="card__content">
          <p><strong>Welcome LakeHouse Analytics!</strong></p>
          <p>Please check your email for a link to verify your email address.  Once verified, you’ll be able to dive in.</p>
          <p>If you have not received a verification email, please check your spam, quarantine or bulk email folder.</p>
          <p>If you need further assistance, contact <a href="mailto:support@lakehouse-analytics.com" target="blank">support</a>.</p>
        </div>
      </div>
    </div>
  </div>
</div>
